import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Modal, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import StateForm from './StateForm';
import { DELETE_STATE, FETCH_STATE, GET_STATE } from 'actions/address';
import { startsWith } from 'components/common/utils';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const StateList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [allStateData, setAllStateData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [stateId, setStateId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseStateData, setPageWiseStateData] = useState([]);

  const stateList = useSelector((state) => state.state.states);
  const isLoader = useSelector((state) => state.state.isLoading);
  const page = useSelector((state) => state.state.page);
  const totalData = useSelector((state) => state.state.total);
  const limit = useSelector((state) => state.state.limit);
  const totalPages = useSelector((state) => state.state.totalPages);

  const stateData = stateList.filter(({ id: id1 }) => pageWiseStateData.some(({ id: id2 }) => id2 === id1));

  const getState = useCallback(
    (data = {}) => {
      dispatch({
        type: FETCH_STATE,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              setPageWiseStateData(res.data.results);
            }
          }
        },
      });
    },
    [pageWiseStateData]
  );

  const getStateDetail = useCallback((id) => {
    dispatch({ type: GET_STATE, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setStateId('');
  };

  const deleteState = useCallback(
    () =>
      dispatch({
        type: DELETE_STATE,
        payload: stateId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getState({ page });
          }
        },
      }),
    [stateId]
  );

  useEffect(() => {
    getState();
  }, []);

  useEffect(() => {
    setAllStateData(
      _.filter(
        stateData,
        (item) =>
          startsWith(_.get(item, 'name', ''), searchText) ||
          startsWith(_.get(item, 'country.name', ''), searchText) ||
          startsWith(_.get(item, 'state_code', ''), searchText)
      )
    );
  }, [searchText, stateList, pageWiseStateData]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getState(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getState(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getState(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormState = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="State" />
        <div className="page-content-wrapper scrollable">
          <div className="stateList-page">
            <Card>
              <div className="stateList-page-wrapper">
                <Row className="stateList-search-box">
                  <Col xl={10} lg={9} md={8} className="stateList-search-inputBox">
                    <SearchBox value={searchText} preIcon={<BsSearch />} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="stateList-search-boxButton">
                    <Button
                      className="stateList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add State
                    </Button>
                  </Col>
                </Row>
                <div className="stateList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>State Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>State Code</span>
                              <span className="ico" onClick={() => handleSorting('state_code', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Country Name</span>
                            </div>
                          </th>
                          <th className="action-col">
                            <div className="sorting">
                              <span>Action</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(allStateData) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">No State Data</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(allStateData, (item, key) => {
                            return (
                              <>
                                <tr key={key}>
                                  <td>{_.get(item, 'name')}</td>
                                  <td>{_.get(item, 'state_code')}</td>
                                  <td>{_.get(item, 'country.name')}</td>
                                  <td>
                                    <span
                                      className="stateList-table_editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getStateDetail(_.get(item, 'id'));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 />
                                    </span>
                                    <span
                                      className="stateList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setStateId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allStateData) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <StateForm onClose={handleCloseFormState} isEdit={isEdit} onSuccess={getState} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="state" onClose={handleCloseDeleteModel} onRemove={deleteState} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default StateList;
